"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSonarObjectApplications = void 0;
const _lib_1 = require("../../lib/index.js");
const sonar_http_1 = require("@sonar-software/sonar-http");
exports.getSonarObjectApplications = (0, _lib_1.createGetFullKeyEndpoint)((_a) => {
    var { sonarObjectId } = _a, rest = __rest(_a, ["sonarObjectId"]);
    return `/api/v3/core/sonar-objects/${sonarObjectId}/applications?${(0, sonar_http_1.getQueryString)(Object.assign(Object.assign({}, rest), { ordering: 'Name~a' }))}`;
});
//# sourceMappingURL=getSonarObjectApplications.js.map